<div class="bg-white" [ngClass]="(srvRpDesign.isMobile$ | async) ? 'p-4' : 'px-0 px-sm-3 m-3'">
  <div class="item-center app-auth-header-icon" [ngClass]="(srvRpDesign.isMobile$ | async) ? 'm-3' : 'm-5'">
    <div>
      <mat-icon svgIcon="falBell" class="icon-center" [ngStyle]="UIUtilityService.getWarningIconStyle()"></mat-icon>
    </div>
  </div>

  <div class="d-flex justify-content-center" [ngStyle]="UIUtilityService.getHeaderStyle()">
    <span
      class="font-dialog-confirm-title text-center"
      [ngClass]="{'mobile-font-dialog-confirm-title': (srvRpDesign.isMobile$ | async)}">
      {{ 'APP_AUTHENTICATOR.WAITING_TITLE' | translate }}
    </span>
  </div>

  <div
    class="font-dialog-confirm-content waiting-content"
    mat-dialog-content
    [ngClass]="(srvRpDesign.isMobile$ | async) ? 'my-3 p-0 mobile-font-dialog-confirm-content' : 'mt-4 mx-3'">
    <p class="text-left mb-3">
      <span class="waiting-step-label">{{ 'APP_AUTHENTICATOR.WAITING_STEP1_LABEL' | translate }}</span>
      {{ 'APP_AUTHENTICATOR.WAITING_STEP1_TEXT' | translate }}
    </p>
    <p class="text-left mb-0">
      <span class="waiting-step-label">{{ 'APP_AUTHENTICATOR.WAITING_STEP2_LABEL' | translate }}</span>
      {{ 'APP_AUTHENTICATOR.WAITING_STEP2_BEFORE' | translate }}
      <span class="waiting-step-label">{{ 'APP_AUTHENTICATOR.WAITING_STEP2_YES' | translate }}</span>
      {{ 'APP_AUTHENTICATOR.WAITING_STEP2_AFTER' | translate }}
    </p>
  </div>

  <div class="waiting-help text-center mt-4 mb-2">
    <a
      class="waiting-help-link"
      href="javascript:void(0)"
      (click)="onStillNotGettingNotification(); $event.preventDefault()">
      {{ 'APP_AUTHENTICATOR.WAITING_STILL_NOT_GETTING' | translate }}
    </a>
  </div>
</div>
